import { axiosClient } from "services/axios";

import {
  AddClientDateParams,
  AddClientParams,
  AddDiscountItemParams,
  ClientTransactionParams,
  EditClientParams,
  SetClientAccountParams,
} from "../types";

export function addClient(params: AddClientParams) {
  return axiosClient.post("users/client", params);
}

export function editClient(params: EditClientParams) {
  return axiosClient.put("users/client", params);
}

export function addDiscountItem(params: AddDiscountItemParams) {
  return axiosClient.post("users/discount-itemgroup", params);
}

export function getDiscountItems(clientid: string, page = 1, pageSize = 100) {
  return axiosClient
    .get("users/discount-itemgroup", {
      params: {
        clientid,
        page,
        pageSize,
      },
    })
    .then((response) => response.data);
}

export function deleteDiscountItem(clientdiscountitemgroupid: number) {
  return axiosClient.post("users/delete-discountitemgroup", {
    clientdiscountitemgroupid,
  });
}

export function clientTransaction(params: ClientTransactionParams) {
  return axiosClient.post("users/client-transaction", params);
}

export function getClientTransactions(clientid: string) {
  return axiosClient
    .get("users/get-transactions", { params: { clientid } })
    .then((res) => res.data);
}

export function getClientDate(clientid: string) {
  return axiosClient
    .get("users/client-date", { params: { clientid } })
    .then((res) => res.data);
}

export function deleteClientDate(clientdateid: string | number) {
  return axiosClient.post("users/delete-date", {
    clientdateid: Number(clientdateid),
  });
}

export function deleteClientTransaction(clienttransactionid: string | number) {
  return axiosClient.post("users/delete-transactions", {
    clienttransactionid: Number(clienttransactionid),
  });
}

export function addClientDate(params: AddClientDateParams) {
  return axiosClient.post("users/client-date", params);
}

export function getClientAccount(clientid: string) {
  return axiosClient
    .get("users/client-account", { params: { clientid } })
    .then((response) => response.data);
}

export function setClientAccount(params: SetClientAccountParams) {
  return axiosClient.put("users/client-account", params);
}

export function transactionCalculation(clientid: string) {
  return axiosClient
    .get("users/transaction-calculation", {
      params: { clientid },
    })
    .then((response) => response.data);
}
